import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from 'gatsby-link';
import { media } from '../../utils/style';
import H4 from '../H4';
import P from '../P';
import ResponsiveImg from '../ResponsiveImg';

const ProjectImg = styled.div`
  align-items: center;
  background-color: ${props => props.theme.projectNoImage};
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin: 5px auto;
  padding: 10px;
  height: 100px;
  width: 100px;
`;

const ProjectCopy = styled.div`
  display: block;
  flex-grow: 1;
  padding: 50px 20px 10px;
  text-align: left;
  transition: padding 0.35s;

  p {
    margin: 0;
  }
`;

const ProjectWrap = styled.div`
  background-color: ${props => props.theme.projectNoImage};
  box-sizing: border-box;
  display: flex;
  margin: 15px auto;
  max-width: 350px;
  position: relative;
  text-align: center;
  width: 100%;

  ${media.desktop`
    margin: 0 0.5%;
    width: 29%;
  `} &:before {
    background-image: ${props =>
      `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23${
        props.theme.projectNoImagePattern
      }' fill-opacity='0.25' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`};
    border-radius: 0 0 100% 100%;
    content: '';
    height: 130px;
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  a {
    display: block;
    position: relative;
    text-decoration: none;
    width: 100%;
    z-index: 2;

    &:hover,
    &:focus {
      ${ProjectCopy} {
        padding-bottom: 20px;
        padding-top: 40px;
      }
    }
  }
`;

let ProjectWithNoImage = ({ link, title, description, image }) => (
  <ProjectWrap>
    <Link to={link} title={`Visit ${title} Project Page`}>
      <ProjectImg>
        <ResponsiveImg src={image} alt={description} />
      </ProjectImg>
      <ProjectCopy>
        <H4 inverse>{title}</H4>
        <P inverse>{description}</P>
      </ProjectCopy>
    </Link>
  </ProjectWrap>
);

ProjectWithNoImage.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired
};

export default ProjectWithNoImage;



// WEBPACK FOOTER //
// ./src/components/ProjectComponents/ProjectWithNoImage.js